import { ITemplateLoanCard } from './ITemplateLoanCard'



const TemplateLoanCard = ({ description, logo, onClick, title }: ITemplateLoanCard) => {
    return (
        <div onClick={onClick} className='p-5 flex justify-start align-top gap-4  rounded-lg border border-[var(--border-color)] bg-[var(--input-bg-color)]'>
            <div className='bg-white rounded-lg border border-[var(--border-color)] w-[70px] h-[70px] aspect-square flex justify-center align-center'>
                <img className='object-cover w-[100%] h-[100%]' src={logo} alt='لوگو' />
            </div>
            <div className='flex flex-col gap-2'>
                <div className='text-[var(--primary-text-color)] text-[.9rem] font-bold'>{title}</div>
                <div style={{ textAlign: 'justify' }} className='text-[var(--text-gray-color)] text-[.8rem]'>{description}</div>
            </div>
        </div>
    )
}

export default TemplateLoanCard